import React from 'react'

import {
    EuiText,
    EuiCallOut
  } from '@elastic/eui'

function PrimaryBox() {
  return (
    <EuiCallOut size="m" iconType="gear" color="success" title="Video Overlays">
        <EuiText>
          <p>
            Set your camera's name and display it in the video stream. Add a timestamp to the video.
          </p>
        </EuiText>
    </EuiCallOut>
  );
}

export default PrimaryBox

